import { useEffect, useMemo, useState } from 'react';
import {
  AccountPasswordValidation,
  validateAccountPassword,
  validateAccountPasswordFallback,
} from '../services/accountSecurity';

export const useAccountPasswordValidation = (password: string): AccountPasswordValidation => {
  const fallbackValidation = useMemo(() => validateAccountPasswordFallback(password), [password]);
  const [validation, setValidation] = useState<AccountPasswordValidation>(fallbackValidation);

  useEffect(() => {
    let cancelled = false;
    setValidation(fallbackValidation);

    if (!password) {
      return () => {
        cancelled = true;
      };
    }

    validateAccountPassword(password).then((result) => {
      if (!cancelled) {
        setValidation(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [fallbackValidation, password]);

  return validation;
};
